import { useEffect, useState, useMemo, Suspense, useRef } from 'react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { BrowserRouter, Route, Switch, Link, NavLink, useHistory, useParams, useRouteMatch, useLocation, Redirect } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { blue } from '@mui/material/colors';
import VideoLabelRoundedIcon from '@mui/icons-material/VideoLabelRounded';
import AudiotrackRoundedIcon from '@mui/icons-material/AudiotrackRounded';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import { Grid, Box, Container, Typography, Pagination } from '@mui/material'
import { format } from 'date-fns'

import { Sound, Movie, File, MultiLineBody } from '../utils/util'
import { CONFIG } from '../states/settings'
import '../../assets/css/index.css'


/*
 *  TODO: 
 *  ページ番号はURLからとっているが、コントローラーから引数で受け取るほうがいいかも
 */
const Items = (props) => {
  let json_file = props.json_file || null;
  let menu_id   = props.menu_id   || null;
  let limit     = props.limit     ?  props.limit    : CONFIG.LIMIT_PER_PAGE
  let use_pager = props.use_pager ?  true           : false
  let use_grid  = props.use_grid  ?  true           : false
  let show_full = props.show_full ?  true           : false
  let from_url  = props.from_url  ?  props.from_url : '/'
  let ui = useLocation()
  let from_entry_id = ui.state ? (ui.state.from_entry_id ? ui.state.from_entry_id : null) : null

  let { id, pagenum } = useParams()
  pagenum = isNaN(pagenum) ? 1 : pagenum
  pagenum--

  let [ items, setItems] = useState([])
  let [ pageCount, setPageCount ] = useState(1)

  let node_selected = useRef(null)

  // invoke url change
  let history = useHistory()


  useEffect(() => {
    if ( !json_file ) return;
  
    (async () => {
      try {
        let url =  CONFIG.API.INFO + json_file.split('.')[0] + CONFIG.API.INFO_EX
        let response = await fetch(url);
        
        if (!response.ok) {
          console.warn('記事リストのHTTPエラー:', response.status, response.statusText);
          return;
        }
        
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          console.warn('記事リストのContent-Typeエラー:', contentType);
          return;
        }
        
        let json = await response.json()

        let data = json.messages || []
        setItems(data)

        // total page number
        let page_count = Math.ceil(data.length / limit)
        setPageCount(page_count)
      } catch (error) {
        console.warn('記事リストの取得エラー:', error);
      }

      // jump y-position pre-readed item
      if (node_selected && node_selected.current && node_selected.current.offsetTop) {
        window.scrollTo(0, node_selected.current.offsetTop)
      }
    })();
  }, [json_file])

  let render_per_page = ()=>{
    let head = pagenum*limit, tail = head + limit
    let feed = items.slice(head, tail)

    let render_full = ()=>{
      return (
        <Box className='item_list_area'>
          <Grid container alignitems="baseline" spacing={2}>
            { feed.map((v,i) => {
              let looked_article = (v.id == from_entry_id) ? 'looked_article' : ''

              return (
                <Grid key={v.id || i} item sm={12} md={12} lg={12} xl={12}>
                  <Box
                    ref={looked_article ? node_selected : null}
                    className={`item_wrapper ${looked_article} ${v.is_emergency ? 'emergency' : ''}`}
                    pt='.7rem' pr='.7rem' pl='.7rem' pb='1.4rem'
                    sx={{
                      // height: '100%',
                      boxShadow: 2, 
                      bgcolor: '#fafafa', 
                      alignItems: 'stretch',
                      borderRadius: 2,
                      border: '1px solid transparent',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
                        transform: 'translateY(-4px)',
                        boxShadow: '0 8px 25px rgba(33, 150, 243, 0.2)',
                        border: '1px solid #2196f3',
                        '& .sender_name': {
                          color: '#1976d2',
                        },
                        '& .time_c1': {
                          color: '#1976d2',
                        },
                      }
                    }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: '1rem' }}>
                    <Typography 
                      className="menu-id-label"
                      variant="caption" 
                      sx={{ 
                        mr: 1, 
                        color: '#1976d2',
                        fontWeight: 'bold',
                        backgroundColor: '#e3f2fd',
                        padding: '2px 8px',
                        borderRadius: '12px',
                        fontSize: '0.75rem'
                      }}
                    >
                      {menu_id}
                    </Typography>
                    <Link to={{
                      pathname: `${CONFIG.PAGE_ROOT_PATH}/${menu_id}/items/${v.id}`,
                      state: {
                        from_url: from_url,
                        page_limit: limit,
                      }
                    }} style={{ textDecoration: 'none', color: 'inherit' }}>
                      <Typography component="h4" variant="h6" fontWeight='600' sx={{
                        lineHeight:'1.4',
                        cursor: 'pointer',
                        position: 'relative',
                        padding: '8px 32px 8px 12px',
                        borderRadius: '8px',
                        backgroundColor: 'rgba(25, 118, 210, 0.05)',
                        border: '1px solid rgba(25, 118, 210, 0.2)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        wordBreak: 'break-word',
                        '&:hover': {
                          color: '#1976d2',
                          backgroundColor: 'rgba(25, 118, 210, 0.1)',
                          border: '1px solid #1976d2',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                          '&::after': {
                            content: '"👆"',
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            fontSize: '14px',
                            opacity: 0.7,
                            pointerEvents: 'none'
                          }
                        },
                        '&::before': {
                          content: '"📖"',
                          marginRight: '8px',
                          fontSize: '16px'
                        }
                      }}>
                        { v.title }
                      </Typography>
                    </Link>
                  </Box>

                  <Grid className='item_list_other' container mb='1.5rem'>
                    <p className='sender_name'>{ v.sender_name }</p>
                    <time className='time_c1' dateTime={format(new Date(v.sent_at),'yyyy-MM-dd HH:mm')}>
                      { format(new Date(v.sent_at),'yyyy-MM-dd HH:mm') }
                    </time>
                  </Grid>

                  <div onClick={(e) => e.stopPropagation()}>
                    <Sound item={ v.sound_file ? v.sound_file : (v.generated_sound_file ? v.generated_sound_file : null)} />
                  </div>

                  <Typography className='mabiku' component="p" variant="h7" mb='1.2rem' sx={{ 
                    fontSize: '.9rem',
                    lineHeight: '1.6'
                  }}>
                    <MultiLineBody body={v.body} />
                  </Typography>

                  <div onClick={(e) => e.stopPropagation()}>
                    <Movie item={ v.movie_url } />
                    <File item={ v.file } />
                  </div>
                  </Box>
                </Grid>
              )
            }) }
          </Grid>
        </Box>
      )
    }

    let render_short = ()=>{
      return (
        feed.map((v,i) => {
          return (
            <Box
              className={`Top_menu_list ${v.is_emergency ? 'emergency' : ''}`}
              sx={{
                '&:hover': {
                  backgroundColor: blue[300],
                  color: '#fff'
                }
              }}
            >
            <Link to={{
              pathname: `${CONFIG.PAGE_ROOT_PATH}/${menu_id}/items/${v.id}`,
              state: {
                from_url: from_url,
                page_limit: limit,
              }
            }}>
              <time className='time_c1' dateTime={format(new Date(v.sent_at),'yyyy-MM-dd')}>{ format(new Date(v.sent_at),'yyyy年MM月dd日 HH時mm分') }</time>
              <Typography component="p">
                { v.title }
              </Typography>
            </Link>
            </Box>
          )
        })
      )
    }

    if (use_grid) {
      return render_short()
    } else {
      return render_full()
    }
  }

  let onPageChange = (pg_info)=>{
    //console.log('onPageChange',pg_info)
  }

  let onPageActive = (pg_info)=>{
    //console.log('onPageActive',pg_info)
  }

  let onClick = (pg_info)=>{
    let page_to = pg_info.nextSelectedPage + 1
    history.push(`/${menu_id}/${page_to}`)
  }

  let changePage = (info, page) => {
    history.push(`${CONFIG.PAGE_ROOT_PATH}/${menu_id}/${page}`)
  }


  return (
    <>
    {
      render_per_page()
    }

    { use_pager
      &&
        <Box mt='3rem'>
        <Pagination
          className={'custom_pagination_itemlist'}
          count={pageCount}
          defaultPage={pagenum+1}
          siblingCount={2}
          boundaryCount={4}
          size="large"
          variant='text'
          color='info'
          onChange={ changePage }
        />
        </Box>
    }
    </>
  );
}


export default Items;
